// src/shared/bug-reporter/visibility.ts
// Pure helper that decides whether the reporter should render. Lives in its
// own file so the React component can be tree-shaken from non-component
// callers (tests, consumers checking visibility before render).

interface IsReporterVisibleOptions {
  /** Explicit override from the BugReporter `enabled` prop. */
  enabledOverride?: boolean
  /** Vite's `import.meta.env.MODE` value, or equivalent. */
  mode?: string
  /** `VITE_ENABLE_BUG_REPORTER` raw value — accepts string or boolean. */
  flagValue?: string | boolean
}

/**
 * Mirrors qa-spec G1/G2 and scope-decisions.md D4: visible in dev/staging or
 * when the flag is explicitly set, hidden in production by default.
 */
export function isReporterVisible(opts: IsReporterVisibleOptions): boolean {
  if (typeof opts.enabledOverride === 'boolean') return opts.enabledOverride
  const flag = typeof opts.flagValue === 'string'
    ? opts.flagValue === 'true'
    : !!opts.flagValue
  if (flag) return true
  const mode = opts.mode ?? 'production'
  return mode !== 'production'
}
